module.exports = __webpack_public_path__ + "img/SES_4101040200.021e4a75.jpg";